export default "__VITE_ASSET__0baedb6c__"